
import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/auth';
import { useTripMembers } from '@/hooks/travel/useTripMembers';
import { TravelersHeader } from './travelers/TravelersHeader';
import { TravelersContent } from './travelers/TravelersContent';

interface TravelersTabProps {
  tripId?: string;
  isAuthorized: boolean;
}

const TravelersTab: React.FC<TravelersTabProps> = ({ tripId, isAuthorized }) => {
  const { members, isLoading, error, fetchTripMembers } = useTripMembers(tripId);
  const { user } = useAuth();

  const handleInvite = () => {
    toast.info("Invite feature coming soon!");
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <TravelersHeader 
          isAuthorized={isAuthorized} 
          onRefresh={fetchTripMembers}
          onInvite={handleInvite}
          tripId={tripId || ''}
        />
      </CardHeader>
      <CardContent>
        <TravelersContent 
          members={members}
          isLoading={isLoading}
          error={error}
          isAuthorized={isAuthorized}
          currentUserId={user?.id}
          onRefresh={fetchTripMembers}
          onInvite={handleInvite}
        />
      </CardContent>
    </Card>
  );
};

export default TravelersTab;
